import { render, staticRenderFns } from "./CardBasic.vue?vue&type=template&id=9db8a46a&scoped=true"
import script from "./CardBasic.vue?vue&type=script&lang=js"
export * from "./CardBasic.vue?vue&type=script&lang=js"
import style0 from "./CardBasic.vue?vue&type=style&index=0&id=9db8a46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db8a46a",
  null
  
)

export default component.exports